import { createApi } from "@reduxjs/toolkit/query/react";
import { magentoBaseQuery } from "./baseQuery";
import { getCartPricesEndpoint, getCustomerCartIdEndpoint, getTrialCartPricesEndpoint } from "./endpoints";
export const magentoApiSlice = createApi({
    reducerPath: "magentoApi",
    baseQuery: magentoBaseQuery,
    tagTypes: ["Cart"],
    endpoints: (builder) => (Object.assign(Object.assign(Object.assign({}, getCustomerCartIdEndpoint(builder)), getCartPricesEndpoint(builder)), getTrialCartPricesEndpoint(builder))),
});
export const { useGetCustomerCartIdQuery, useGetCartPricesQuery, useGetTrialCartPricesQuery } = magentoApiSlice;
//# sourceMappingURL=magentoApiSlice.js.map